// @flow

import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import Store from "../../store";

import { removeFromCart } from "../../actions/cart";
import formatCurrency from "../../utils/formatCurrency";
import Image from "../atoms/Image";
import LinkHandler from "../atoms/LinkHandler";
import ShowMore from "../atoms/ShowMore";
import _ from "lodash";

type PropsType = {
    className?: string,
    id: string,
    name: string,
    cartKey: string,
    permalink: string,
    summary?: boolean,
    quantity: number,
    variation: Array<{ value?: string }>,
    prices: { regular_price: number, sale_price: number },
    images?: Array<{ thumbnail?: string }>,
};

const CartItem = (props: PropsType): React.Node => {
    const user = Store.getState().user;
    const { cartItemUrls } = useSelector((state: any): any => state.cart);
    const dispatch = useDispatch();
    const cssBaseClass = "cart-item";
    const classList = [cssBaseClass];
    const enableShowMoreData = props.item_data
        ? props.item_data.find(form => {
              return (
                  (!_.has(form, "price_at_the_first_add") &&
                      _.has(form, "team_name")) ||
                  _.omit(
                      (Object.fromEntries(
                          Object.entries(form).filter(([key, value]) => value)
                      ),
                      "free_text_label").length > 0
                  )
              );
          })
        : false;

    const default_tile_image = useSelector(
        (state: any): any => state.options.default_tile_image
    );

    if (props.className) {
        classList.push(props.className);
    }

    if (props.summary) {
        classList.push("cart-item--summary");
    }
    if (
        props.uts_discountable === true &&
        user.nonce?.user_discount_percentage &&
        user.nonce?.user_discount_percentage > 0
    ) {
        classList.push("cart-item--member-discount");
    }

    const productPageUrl =
        cartItemUrls && cartItemUrls[props.id]
            ? cartItemUrls[props.id]
            : props.permalink.split("?")[0];

    return (
        <div className={classList.join(" ")}>
            <div className="cart-item__image">
                <LinkHandler to={productPageUrl}>
                    <Image
                        src={
                            props.images && props.images["1"]
                                ? props.images["1"].thumbnail
                                : props.images && props.images[0]
                                ? props.images[0].thumbnail
                                : default_tile_image.sizes.medium_large
                        }
                        aspectRatio="1:1"
                        alt={props.name}
                        skeleton={true}
                    />
                </LinkHandler>
            </div>

            <div className="cart-item__content">
                <div className="cart-item__name">{props.name}</div>

                {props.variation && props.variation.length ? (
                    <div className="cart-item__variations">
                        {props.variation
                            .map((variation: { value: any }) => {
                                return variation.value;
                            })
                            .join(", ")}
                    </div>
                ) : null}

                <div className="cart-item__quantity">
                    Qty:{" "}
                    <span className="cart-item__quantity__value">
                        {props.quantity}
                    </span>
                </div>

                {!props.summary && enableShowMoreData ? (
                    <ShowMore collapsedHeight={25}>
                        <div className="cart-item__form-details">
                            {props.item_data.map((form, index) => {
                                const renderFields = (memberForm, index) => {
                                    const memberFields = {
                                        Name:
                                            memberForm.first_name &&
                                            memberForm.last_name &&
                                            `${memberForm.first_name} ${memberForm.last_name}`,
                                        Email: memberForm.email,
                                        "Student number": memberForm.uts_id,
                                        Gender: memberForm.gender,
                                        "Dietary requirements":
                                            memberForm.dietary_requirements,
                                        "Tshirt size": memberForm.tshirt_size,
                                        "Teammate request":
                                            memberForm.teammate_request,
                                        "Accessibility requirements":
                                            memberForm.accessibility_requirements,
                                        "Emergency contact info":
                                            memberForm.emergency_contact,
                                        Age: memberForm.under_18,
                                        [form.free_text_label ??
                                        "Additional comments"]:
                                            memberForm.free_text,
                                    };

                                    return (
                                        <div {...{ key: index }}>
                                            <div className="cart-item__form-details__item">
                                                {index != null ? (
                                                    <span className="cart-item__form-details__item__label">
                                                        Member {index + 1}:
                                                    </span>
                                                ) : null}
                                                {Object.entries(
                                                    memberFields
                                                ).map(([key, value], i) => {
                                                    return value ? (
                                                        <div
                                                            key={i}
                                                            className="cart-item__form-details__item"
                                                        >
                                                            <span
                                                                className={`cart-item__form-details__item__label${
                                                                    index !=
                                                                    null
                                                                        ? " cart-item__form-details__item__label--indented"
                                                                        : ""
                                                                }`}
                                                            >
                                                                {key} -{" "}
                                                            </span>
                                                            {value}
                                                        </div>
                                                    ) : null;
                                                })}
                                            </div>
                                        </div>
                                    );
                                };

                                return (
                                    <div key={index}>
                                        {form.team_name ? (
                                            <div>
                                                {form.team_name ? (
                                                    <div className="cart-item__form-details__item">
                                                        <span className="cart-item__form-details__item__label">
                                                            Team name:
                                                        </span>{" "}
                                                        {form.team_name}
                                                    </div>
                                                ) : null}
                                                {form.free_text_label &&
                                                form.free_text ? (
                                                    <div className="cart-item__form-details__item">
                                                        <span className="cart-item__form-details__item__label">
                                                            {
                                                                form.free_text_label
                                                            }
                                                            :
                                                        </span>{" "}
                                                        {form.free_text}
                                                    </div>
                                                ) : null}
                                                {JSON.parse(form.members).map(
                                                    renderFields
                                                )}
                                            </div>
                                        ) : (
                                            renderFields(form)
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </ShowMore>
                ) : null}

                {!props.summary ? (
                    <button
                        className="cart-item__remove"
                        onClick={() => dispatch(removeFromCart(props.cartKey))}
                    >
                        Remove
                    </button>
                ) : null}
            </div>

            <div className="cart-item__amounts">
                {props.prices.regular_price === props.prices.sale_price ? (
                    <div className="cart-item__amounts__regular">
                        {formatCurrency(
                            props.prices.regular_price * props.quantity
                        )}
                    </div>
                ) : (
                    <>
                        <div className="cart-item__amounts__sale-price">
                            {formatCurrency(
                                props.prices.sale_price * props.quantity
                            )}
                        </div>
                        <div className="cart-item__amounts__regular-discount">
                            {formatCurrency(
                                props.prices.regular_price * props.quantity
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default CartItem;
